import { useState } from "react";
import { useForm } from "react-hook-form";
import { useAlert } from '../../../shared/components/AlertProvider';
import Flex from '../../../shared/components/Flex';
import Grid from '../../../shared/components/Grid';
import GridChild from '../../../shared/components/GridChild';
import LabelInput from '../../../shared/components/LabelInput';
import ModalButton from '../../../shared/components/ModalButton';
import Spacer from '../../../shared/components/Spacer';
import ToggleButtonSelect from '../../../shared/components/ToggleSelect';
import useDevice from '../../../shared/hooks/useDevice';
import { responseMsg } from "../../common/ResponseMsg";

function CodeEditModal({code, rendering}) {
    const { register, handleSubmit, formState: { isSubmitting, isDirty, errors }} = useForm({
        defaultValues : code
    });
    const [useYn, setUseYn] = useState(code?.useYn ?? "Y");
    const device = useDevice();
    const isMobile = device !== 'desktop'
    const showAlert = useAlert();

    const useYnOption = [
        {text: "사용", value: "Y"},
        {text: "미사용", value: "N"}
    ]

    const onUpdateHandler = (formData) => {
        if (formData.name.trim() === '') {
            showAlert({title: "주의", text: "코드명을 입력해주세요.", type: "warning" });
            return;
        }
        fetch("/api/system/codes",{
            method:"PATCH",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({...formData, useYn}),
            })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "수정완료"});
                    rendering();
                    
                }  else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    }

    return (
        <div>
            <form className="input_wrap">
                <Grid paddingX={0}>
                    <GridChild span={2}>
                        <LabelInput 
                            label="코드명"
                            defaultValue={code.name}
                            {...register("name")}
                            autoFocus
                            required
                        />
                    </GridChild>
                    <GridChild span={2}>
                        <LabelInput 
                            label="Comment"
                            defaultValue={code.comment}
                            {...register("comment")}
                        />
                    </GridChild>
                </Grid>

            </form>

            <Spacer direction='vertical' size={22} />

            <ToggleButtonSelect
                label="사용여부"
                name="usage_status"
                options={useYnOption}
                onChange={(value) => setUseYn(value)}
                initialValue={useYn}
            />

            <Spacer direction='vertical' size={22} />

            <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                <ModalButton type="update" onClick={handleSubmit(onUpdateHandler)} />
                <ModalButton type="cancel" onClick={rendering} />
            </Flex>
        </div>
    );
}

export default CodeEditModal;